import React from "react";
import { colorFor } from "../utils/presenceColors";

const MAX_SHOWN = 4;

const initials = (name) => {
  const parts = String(name || "?").trim().split(/\s+/u).filter(Boolean);
  const letters = parts.length > 1 ? [parts[0], parts[parts.length - 1]] : [parts[0] || "?"];
  return letters.map((w) => Array.from(w)[0]).join("").toLocaleUpperCase();
};

const agoText = (iso) => {
  if (!iso) return "";
  const sec = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (Number.isNaN(sec)) return "";
  if (sec < 45) return "ახლა";
  return `${Math.round(sec / 60)} წთ წინ`;
};

/** Row of coloured initial circles for the people working on a project right now. */
export default function PresenceBadge({ people, label = true }) {
  if (!Array.isArray(people) || people.length === 0) return null;
  const shown = people.slice(0, MAX_SHOWN);
  const extra = people.length - shown.length;
  const title = people
    .map((p) => `${p.name || "—"}${agoText(p.last_seen) ? ` · ${agoText(p.last_seen)}` : ""}`)
    .join("\n");

  return (
    <div
      data-no-translate="true"
      title={title}
      style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}
    >
      <div style={{ display: "flex", flexShrink: 0 }}>
        {shown.map((p, i) => (
          <span
            key={p.user_id}
            style={{
              width: 22, height: 22, borderRadius: "50%", background: colorFor(p.user_id),
              color: "#fff", fontSize: 10, fontWeight: 700, display: "inline-flex",
              alignItems: "center", justifyContent: "center",
              marginLeft: i === 0 ? 0 : -6, border: "2px solid var(--surface-soft, #1e2530)",
              position: "relative",
            }}
          >
            {initials(p.name)}
          </span>
        ))}
        {extra > 0 && (
          <span style={{ marginLeft: 4, fontSize: 11, alignSelf: "center", color: "var(--text-muted)" }}>
            +{extra}
          </span>
        )}
      </div>
      {label && (
        <span
          style={{
            fontSize: 12, color: "#22c55e", overflow: "hidden", textOverflow: "ellipsis",
            whiteSpace: "nowrap", display: "inline-flex", alignItems: "center", gap: 5,
          }}
        >
          <span style={{ width: 7, height: 7, borderRadius: "50%", background: "#22c55e", flexShrink: 0 }} />
          ახლა მუშაობს: {people.map((p) => p.name || "—").join(", ")}
        </span>
      )}
    </div>
  );
}
